import PlatformBreakoutDashboard from './PlatformBreakoutDashboard';

export default PlatformBreakoutDashboard;
